// extracted by mini-css-extract-plugin
export var author = "glossary-post-module--author--2005b";
export var authorDesktop = "glossary-post-module--author-desktop--3afd9";
export var authorMobile = "glossary-post-module--author-mobile--6a8b2";
export var blogPostArticle = "glossary-post-module--blog-post-article--e89e2";
export var category = "glossary-post-module--category--37c7e";
export var description = "glossary-post-module--description--c0aa3";
export var header = "glossary-post-module--header--c9477";
export var headline = "glossary-post-module--headline--454c7";
export var headlinePost = "glossary-post-module--headline-post--2c370";
export var image = "glossary-post-module--image--c964c";
export var linkToLexicon = "glossary-post-module--link-to-lexicon--587d3";
export var linkToLexicon__arrowIcon = "glossary-post-module--link-to-lexicon__arrowIcon--cb748";
export var paragraph = "glossary-post-module--paragraph--c9936";
export var section = "glossary-post-module--section--aa694";
export var title = "glossary-post-module--title--383a4";